import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-driver-proof-of-insurance-popover',
  templateUrl: './driver-proof-of-insurance-popover.component.html',
  styleUrls: ['./driver-proof-of-insurance-popover.component.scss']
})
export class DriverProofOfInsurancePopoverComponent implements OnInit {

  @Input()
  show = false;

  @Output()
  closePopup: EventEmitter<any> = new EventEmitter();

  displayExpiredNotice: boolean = false;

  close(): void {
    this.closePopup.emit();
  }

  onClickInsuranceImage(): void {
    this.displayExpiredNotice = true;
  }

  constructor() { }

  ngOnInit(): void {
  }

  closePopOver(): void {
    this.displayExpiredNotice = false;
  }

}
